import { PROGRAM_TYPES } from 'site-modules/shared/components/incentives/incentives-wizard/constants/program-types';
import { isLocalEvRebate } from 'site-modules/shared/components/incentives/incentives-wizard/utils/is-local-ev-rebate';

export function isLocalRebate(incentive) {
  const { programType } = incentive;
  return (
    isLocalEvRebate(incentive) || [PROGRAM_TYPES.CHARGER_INSTALLATION, PROGRAM_TYPES.TAX_CREDIT].includes(programType)
  );
}
